import { StBadge } from './Badge.styled'

import type { ReactNode } from 'react'

type BadgeProps = {
  children: ReactNode
  number?: number
}

export const Badge = ({ children, ...props }: BadgeProps) => {
  return <StBadge {...props}>{children}</StBadge>
}
